import Combobox from "@/components/custom/Combobox";
import { useFieldContext } from "@/features/question/components/organisms/FieldRenderer";
import { cn } from "@/lib/utils";
import { Check } from "lucide-react";
import { useCallback, useEffect, useMemo, useState } from "react";

export function PickListMultipleRenderer() {
    const { question, disabled, response, form, currentValue } = useFieldContext();
    const [value, setValue] = useState<string[]>([]);

    const options = useMemo(
        () => (question?.field_options as string[])?.map(option => option.trim()),
        [question?.field_options]
    );

    const items = useMemo(
        () => options?.map(option => ({ label: option, value: option })) ?? [],
        [options]
    );
    const setFormValue = useCallback((val: string[]) => {
        if (!disabled && form?.setValue) {
            form.setValue("additional", JSON.stringify(val));
        }
    }, [form, disabled]);

    useEffect(() => {
        if(currentValue) {
            setValue(currentValue);
        }
    }, [currentValue]);

    useEffect(() => {
        setFormValue(value);
    }, [setFormValue, value]);

    return (
        <div className="flex flex-col gap-2">
            {!disabled && (
                <Combobox
                    inDialog
                    triggerLabel={"Select a value"}
                    mode="multiple"
                    selectedValue={value}
                    setSelectedValue={setValue}
                    items={items}
                    disabled={disabled}
                />
            )}


            {disabled && (
                <div className="flex flex-wrap gap-2">
                    {options?.map((option, index) => (
                        <div
                            key={option + index}
                            className={cn(`flex justify-center items-center rounded-full px-3 py-1 text-xs border min-w-[50px]`,
                                disabled ? response?.field_value?.includes(option) ? "bg-green-200 border-green-300" : "bg-gray-200 border-gray-300" : value.includes(option)
                            )}
                        >
                            {option}
                            {disabled ? response?.field_value?.includes(option) && <Check size="16" className="text-green-700 ms-1" /> : value.includes(option)}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}